import type { ClientError } from 'graphql-request'

export const isClientError = (err: unknown): err is ClientError => {
  if (err instanceof Error) {
    if (err.hasOwnProperty('response') && err.hasOwnProperty('request'))
      return true
  }
  return false
}
